<template>
  <b-container>
    <!-- HEADER -->
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3 class="font-weight-bold mb-0">Custom Reports</h3>
            <small class="text-muted">
              Build custom reports with your own parameters
            </small>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col md="4">
              <b-form-group label="Report Type">
                <b-form-select
                  v-model="form.reportType"
                  :options="reportTypes"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Date Range">
                <b-form-select v-model="form.dateRange" :options="dateRanges" />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Format">
                <b-form-select v-model="form.format" :options="formats" />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-row>
                <b-col md="6">
                  <b-form-group label="Filters">
                    <b-form-select
                      v-model="form.filters"
                      :options="filterOptions"
                      multiple
                      :select-size="5"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Columns">
                    <b-form-select
                      v-model="form.columns"
                      :options="columnOptions"
                      multiple
                      :select-size="5"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="12">
              <b-button variant="primary">
                <feather-icon icon="SettingsIcon" size="14" />
                Generate Report
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormSelect,
  BButton,
  BFormGroup,
} from "bootstrap-vue";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormSelect,
    BButton,
    BFormGroup,
  },
  data() {
    return {
      form: {
        reportType: "Betting Activity",
        dateRange: "Today",
        format: "Excel (.xlsx)",
        filters: [],
        columns: [],
      },
      reportTypes: ["Betting Activity", "Customer Activity", "Revenue Summary"],
      dateRanges: ["Today", "Yesterday", "Last 7 Days", "This Month"],
      formats: ["Excel (.xlsx)", "CSV", "PDF"],
      filterOptions: [
        "Racing Only",
        "Sports Only",
        "VIP Customers",
        "High Value Bets",
      ],
      columnOptions: [
        "Bet ID",
        "Customer",
        "Amount",
        "Odds",
        "Profit/Loss",
        "Date",
      ],
    };
  },
};
</script>